<div class="preview-wrapper" [class.preview-wrapper--inline]="inline">
  @if (!inline) {
    <mat-icon (click)="closeDialog()" class="close">close</mat-icon>
  }
  
      <mat-progress-spinner class="spinner"  [style]="{'visibility' : isLoading() ? 'visible': 'hidden'}"
        [mode]="'indeterminate'" [strokeWidth]="4" [diameter]="50">
      </mat-progress-spinner>
     
      @switch (extension()) {
    
          @case (PreviewExtension.IMAGE) {
            <img [src]="url()" class="preview-image" (load)="onLoaded()" loading="eager">
          }
    
          @case (PreviewExtension.VIDEO) {
            <video controls class="preview-image" (load)="onLoaded()" >
              <source [src]="url()" [type]="videoType()">
              Your browser does not support the video 
            </video>
          }

          @case (PreviewExtension.PDF) {
              <iframe  class="preview-image" [src]="url()" (load)="onLoaded()" ></iframe>
          }
    
          @default {
           <ngx-doc-viewer [url]="url()" [disableContent]="'popout-hide'" [googleCheckContentLoaded]="true" [googleCheckInterval]="1" [googleMaxChecks]="5" [viewer]="type()"
             class="preview-image" (load)="onLoaded()">
           </ngx-doc-viewer>
          }
    
      }
  
</div>  